<template>
	<div class="answer-checkbox position-rel" :class="`answer--${parent.type}`">
		<input :name="nameField" type="checkbox" :value="dataSource.content ? dataSource.content : dataSource.imageUrl" :checked="dataSource.success || dataSource.err || dataSource.answerContent" @change="handleChangeAnswer($event, {location, type: parent.type, questionId: dataSource.questionId, dataSource})">
		<label
			class="display-flex-center"
			:class="{
        'answer__err': !isDontShowResultSaved && statusCorrect === 'err',
				'answer__true': !isDontShowResultSaved && statusCorrect === 'success'
			}"
		>
			<span class="check-icon position-rel"></span>
			<span class="check-data display-flex-center">
				<b v-if="dataSource.code">{{ dataSource.code }} </b>
				<span v-html="dataSource.content"></span>
			</span>
		</label>
	</div>
</template>

<script>
	import mixinsQuestionPreview from './../../_store/mixinsQuestionPreview'

	export default {
		name: 'MultipleAnswer',
		mixins: [ mixinsQuestionPreview ],
		data () {
			return {
			}
		},
		methods: {
			handleChangeAnswer(evt, data) {
				if(!evt.target.checked) {
					data.dataSource.answerContent = null
				}
				this.changeAnswer(evt, data)
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import './../../../../../assets/scss/mixins';
	@import './../../../../../assets/scss/variables';
	@import './../../../../../assets/scss/general';

	.answer-checkbox {
		margin-bottom: 15px;

		input {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			cursor: pointer;
			opacity: 0;
			z-index: 1;

			&:checked ~ label {
				&:not(.answer__err) {
					.check-icon {
						border-color: $color_success;
					}
				}

				.check-icon:after {
					opacity: 1;
				}
			}
		}

		label {
			color: $color_txt;

			b {
				margin-right: 15px;
			}
			
			// &:before, &:after {
			// 	content: "";
			// }

			.check-icon {
				width: 20px;
				height: 20px;
				border: 1px solid #ccc;
				margin-right: 8px;

				&:after {
					content: "";
					width: 16px;
				    height: 16px;
				    position: absolute;
				    left: 1px;
				    opacity: 0;
				    @extend .position-center-y;
				}
			}

			.check-data display-flex-center {
				width: calc(100% - 28px);
			}


			&:not(.answer__error) {
				.check-icon:after {
					background: url('./../../../../../assets/images/tick.png') no-repeat;
					background-size: 100%;
				}
			}

			&.answer__err {
				color: $color_err_question;
				.check-icon {
					border-color: $color_err_question;
					
					&:after {
						background: url('./../../../../../assets/images/tick-error.png') no-repeat;
						background-size: 100%;
					}
				}
			}
		}

		&.answer--x_mark_answer {
			label {
				.check-icon {

					&:after {
						background: url('./../../../../../assets/images/x-mark.png') no-repeat;
						background-size: 80%;
	    				background-position: center;
					}
				}

				&.answer__err {
					.check-icon {

						&:after {
							background: url('./../../../../../assets/images/x-mark-error.png') no-repeat;
							background-size: 80%;
	    					background-position: center;
						}
					}
				}
			}
		}

		&.answer--circle_answer {
			display: inline-block;
			label {
				display: inline-block;
				padding: 6px 15px;

				.check-icon {
					display: none;
				}

				&:before {
					content: "";
					opacity: 0;
					width: 100%;
					height: 100%;
					position: absolute;
					top: 0;
					left: 0;
					border-radius: 50%;
				}

				// &:not(.answer__err) {
				// 	&:before {
				// 		border: 1px solid $primary_color;
				// 	}
				// }
			}

			input:checked ~ label:before {
				opacity: 1;
				border: 1px solid $primary_color;
			}

		}
	}

	.question--circle_answer {
		.answer__true {
			label:before, input:checked ~ label:before {
				border: 1px solid $color_success;
				opacity: 1;
			}
		}

		.answer__err {
			label:before, input:checked ~ label:before {
				border: 1px solid $color_err_question;
			}
		}
	}
</style>